var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubbleBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 547,
    height: 737,
    viewBox: "0 0 547 737",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273.299 609.004C414.521 609.004 529.003 494.522 529.003 353.301C529.003 212.079 414.521 97.5969 273.299 97.5969C132.078 97.5969 17.5957 212.079 17.5957 353.301C17.5957 494.522 132.078 609.004 273.299 609.004Z",
    stroke: "url(#paint0_linear_1168_33818)",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3 735.6C484.438 735.6 655.6 564.438 655.6 353.3C655.6 142.162 484.438 -29 273.3 -29C62.1615 -29 -109 142.162 -109 353.3C-109 564.438 62.1615 735.6 273.3 735.6Z",
    stroke: "url(#paint1_linear_1168_33818)",
    strokeOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3 546.181C379.825 546.181 466.181 459.825 466.181 353.3C466.181 246.775 379.825 160.419 273.3 160.419C166.774 160.419 80.4185 246.775 80.4185 353.3C80.4185 459.825 166.774 546.181 273.3 546.181Z",
    stroke: "url(#paint2_linear_1168_33818)",
    strokeOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1168_33818",
    x1: 273.299,
    y1: 97.2521,
    x2: 273.299,
    y2: 609.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1F16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1168_33818",
    x1: 273.3,
    y1: -29.3446,
    x2: 273.3,
    y2: 735.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1F16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1168_33818",
    x1: 273.3,
    y1: 160.074,
    x2: 273.3,
    y2: 546.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD601"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1F16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleBack);
export default __webpack_public_path__ + "static/media/bubble-back.b0099f42161ebc776e835dd39b800f18.svg";
export { ForwardRef as ReactComponent };